import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackFacebookPageView } from "@/utils/fbPixel";

function usePageTracking() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    trackFacebookPageView();
  }, [location.pathname]);
}

export default usePageTracking;
